<wa-dialog
  label="{{ title }}"
  open="true"
  (waHide)="cancel()"
  withFooter="true">

  <p>{{ message }}</p>

  <div slot="footer" class="wa-cluster">
    @if (cancel_button) {
      <wa-button variant="danger" appearance="filled" (click)="cancel()">Cancel</wa-button>
    }
    <wa-button
      variant="brand"
      appearance="filled"
      (click)="confirm()">
      Confirm
    </wa-button>
  </div>
</wa-dialog>
